export const defaultBannerList = [
    { image: require("../assets/img/join/banner/0.png"), link: '#' },
    { image: require("../assets/img/join/banner/1.png"), link: '#' },
    { image: require("../assets/img/join/banner/2.png"), link: '#' },
    { image: require("../assets/img/join/banner/3.png"), link: '#' },
]